/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AUTOGRADERSTUDENTFEEDBACKOutput } from './autograderStudentFeedbackOutput';
import type { PltStudentComment } from './pltStudentComment';
import type { PltBusinessStudentComment } from './pltBusinessStudentComment';
import type { LegacyRemark } from './legacyRemark';
import type { SubmissionFeedbackPropertyAnyOf } from './submissionFeedbackPropertyAnyOf';

export type SubmissionFeedbackProperty =
  | AUTOGRADERSTUDENTFEEDBACKOutput
  | PltStudentComment
  | PltBusinessStudentComment
  | LegacyRemark
  | SubmissionFeedbackPropertyAnyOf
  | null;
